import { render, staticRenderFns } from "./DojoWidget.vue?vue&type=template&id=10dcd6ae&"
import script from "./DojoWidget.vue?vue&type=script&lang=js&"
export * from "./DojoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports